<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card class="table-card">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="md-layout">
            <div class="card-icon md-size-10">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="md-layout-item md-size-40 title">{{ title }}</h4>
            <div class="md-size-25 ml-auto">
              <slot name="header"></slot>
            </div>
          </div>
        </md-card-header>

        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
            v-show="!loading"
          >
            <md-table-toolbar>
              <div class="md-layout">
                <p>mostrar</p>
                <md-field class="mt-auto">
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >{{ item }}</md-option>
                  </md-select>
                </md-field>
                <p>elementos</p>
              </div>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  :placeholder="searchPlaceholder"
                  v-model="searchQuery"
                  ref="searchField"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="header" v-for="(header, key) in tableHeaders" :key="key">
                <component
                  :is="tableComponents[key].component"
                  v-bind="tableComponents[key].bind(item[key], item)"
                  v-if="tableComponents[key]"
                ></component>
                <template v-else-if="tableFilters[key]">{{ tableFilters[key](item[key]) }}</template>
                <template v-else>
                  <slot :name="`${key}-cell`" :item="item" :value="item[key]">{{ item[key] }}</slot>
                </template>
              </md-table-cell>
              <md-table-cell md-label="Acciones">
                <md-button
                  v-for="action in allowedActions"
                  :key="action.icon"
                  class="md-just-icon md-info md-simple"
                  style="margin-right: 5px"
                  @click.native="action.exe(item)"
                >
                  <md-icon>{{ action.icon }}</md-icon>
                  <md-tooltip md-direction="top" class="action-tooltip" v-if="action.tooltip">
                    <md-icon>{{ action.icon }}</md-icon>
                    {{ action.tooltip }}
                  </md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <loading-content
            :loading="loading"
            v-bind="loadingContentProps"
            v-if="(loading || loadingContentProps) && !queriedData.length"
          />

          <slot></slot>

          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th v-for="item in footerTable" :key="item.name" class="md-table-head">
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Mostrando {{ to }} de {{ total }} entradas</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import Fuse from "fuse.js";
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";

export default {
  components: {
    Pagination,
  },

  mixins: [usesAccountInfoMixin],

  props: {
    title: String,
    value: null,
    tableHeaders: Object,
    tableData: {
      type: Array,
      default: () => [],
    },
    actions: Array,
    footerTable: Array,
    tableFilters: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableComponents: {
      type: Object,
      default: () => {
        return {};
      },
    },

    currentSort: {
      type: String,
      default: "name",
    },
    currentSortOrder: {
      type: String,
      default: "asc",
    },
    // FIXME: pending fix> table dont search, fix here
    propsToSearch: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingContentProps: {
      type: Object,
      default: null,
    },
    dummySearch: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    paginationTotalItems: {
      type: Number,
      default: 0,
    },
    paginationInfo: {
      type: Object,
      default: null,
      validator(value) {
        const valueKeys = Object.keys(value);
        const paginationProps = ["count", "next", "previous"];

        return !paginationProps.some((key) => valueKeys.indexOf(key) == -1);
      },
    },
    searchPlaceholder: {
      type: String,
      default: "Buscar en Registros",
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (!this.dummySearch && this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return 0;
    },
    total() {
      if (this.paginationTotalItems > 0) {
        return this.paginationTotalItems;
      } else if (this.paginationInfo) {
        const paginationInfo = this.paginationInfo;
        return (paginationInfo && paginationInfo.count) || 0;
      } else {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },

    currentPage: {
      get() {
        if (this.paginationInfo) {
          const next = this.paginationInfo.next;

          if (!next) {
            return this.paginationInfo.previous + 1;
          }
          return next - 1;
        } else {
          return this.pagination.currentPage;
        }
      },
      set(page) {
        let value = {
          page: page,
          size: this.pagination.perPage,
        };
        this.$emit("pageUpdated", page);
        this.$emit("input", value);

        if (this.paginationInfo) {
        } else {
          this.pagination.currentPage = page;
        }
      },
    },

    allowedActions() {
      const actions = this.actions || [];
      return actions.filter((action) => {
        const roles = action.roles;

        return !roles || roles.length == 0 || this.userRoleIs(...roles, "ADM");
      });
    },
  },
  data() {
    return {
      pagination: {
        perPage: this.pageSize,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      content: this.value,
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    focusSearch() {
      const searchField = this.$refs.searchField;
      searchField.$el.focus();
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: this.propsToSearch,
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      this.$emit("updatedSearchQuery", value);

      if (this.dummySearch) {
        return;
      }

      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    tableData(value) {
      this.fuseSearch.list = value;
    },
    "pagination.perPage"(value) {
      this.$emit("updatedPageSize", value);
    },
  },
};
</script>

<style lang="css" scoped>
.md-card.table-card {
  z-index: 0;
}

.md-card-content > .md-content {
  max-height: 1000px;
}

.mt-auto {
  margin-top: -10px !important;
  margin-right: 5px !important;
  margin-left: 5px !important;
}

.action-tooltip {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Tables/CatalogTableAsync.vue